import { Box, Button, Dialog, Paper, Stack, Typography } from '@mui/material';
import { useContext, useEffect, useState } from 'react';
import { createUser, deleteUser, listRoles, listUsers, updateUser } from '../api/user';
import { User, UserCreation } from '../types/api/User';
import { DataGrid } from '@mui/x-data-grid';
import AddIcon from '@mui/icons-material/Add';
import UserForm from '../forms/UserForm';
import { Role } from '../types/api/Role';
import { AppContext } from '../context/appContext';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import YesNoPopup from '../components/Popups/YesNoPopup';
interface FormationsProps {

}

function Users(FormationsProps: FormationsProps) {
    const appContext = useContext(AppContext); 
    
    const [roles, setRoles] = useState<Role[]>([]);
    const [users, setUsers] = useState<User[]>([]);

    const updateRolesList = async () => {
        const res = await listRoles();
        if(res && res.data){
            await setRoles(res.data);
        }
    }

    const updateUsersList = async () => {
        const res = await listUsers();
        if(res && res.data){
            await setUsers(res.data);
        }
    }



    const [openUserForm, setOpenUserForm] = useState(false);
    const [userFormMode, setUserFormMode] = useState<'add' | 'edit'>('add');
    const [newUser, setNewUser] = useState<UserCreation>({email: '', password: '', name: '', role: {id: 0, label: ''}} as UserCreation);

    const handleOpenCreateUserForm = () => {
        setNewUser({email: '', password: '', name: '', role: {id: 0, label: ''}} as UserCreation);
        setUserFormMode('add');
        setOpenUserForm(true);
    }

    const handleOpenEditUserForm = (user: UserCreation) => {
        setNewUser(user);
        setUserFormMode('edit');
        setOpenUserForm(true);
    }

    const createUserAction = async () => {
        const res = await createUser(newUser);
        if(res.code === 200){
            appContext.showSnackbar('Utilisateur créé avec succès', 'success');
            updateUsersList();
            setOpenUserForm(false);
        }
    }

    const updateUserAction = async () => {
        const res = await updateUser(newUser);
        if(res.code === 200){
            appContext.showSnackbar('Utilisateur créé avec succès', 'success');
            updateUsersList();
            setOpenUserForm(false);
        }
    }

    const [openDeleteUserForm, setOpenDeleteUserForm] = useState(false);
    const [toDeleteUsers, setToDeleteUsers] = useState<number>(-1);

    const handleOpenDeleteUserForm = (userId: number) => {
        setOpenDeleteUserForm(true);
        setToDeleteUsers(userId);
    }

    const deleteUserAction = async () => {
        const res = await deleteUser(toDeleteUsers);
        if(res.code === 200){
            appContext.showSnackbar('Utilisateur supprimé avec succès', 'success');
            updateUsersList();
            setOpenDeleteUserForm(false);
        }
    }


    
    const headers = [
        { field: 'id', headerName: 'ID', width: 70 },
        { field: 'name', headerName: 'Name', width: 200 },
        { field: 'email', headerName: 'Email', width: 250 },
        { field: 'role', headerName: 'Role', width: 150, valueGetter: (value: any) => value?.label || '' },
        { field: 'lastLogin', headerName: 'Dernière connexion', width: 250 },
        {
            field: 'actions',
            headerName: 'Actions',
            width: 280,
            sortable: false,
            renderCell: (params: any) => {
                return (
                    <Box>
                        <Stack direction="row" spacing={1}>
                            <Button
                                onClick={()=>{handleOpenEditUserForm(params.row)}}
                                variant="contained"
                                startIcon={<EditIcon />}
                            >
                                Éditer
                            </Button>
                            <Button
                                onClick={()=>{handleOpenDeleteUserForm(params.row.id)}}
                                variant="contained"
                                startIcon={<DeleteIcon />}
                                color='error'
                            >
                                Supprimer
                            </Button>
                        </Stack>
                    </Box>
                    
                )
            }
        }
    ]


    useEffect(() => {
        updateRolesList();
        updateUsersList();
    }, []);

    return (
        <>
            <Paper elevation={0} sx={{padding: 2}}>
                <Stack direction="row" spacing={2} alignItems="center" justifyContent="space-between" sx={{paddingY: 2}}>
                    <Typography variant='h5'>Gestion des utilisateurs</Typography>
                    <Stack>
                        <Button
                            startIcon={<AddIcon />}
                            variant='contained'
                            color='success'
                            onClick={handleOpenCreateUserForm}
                        >
                            Créer
                        </Button>
                    </Stack>
                </Stack>
                <DataGrid
                    disableColumnMenu
                    disableColumnSorting
                    disableRowSelectionOnClick
                    rows={users} 
                    columns={headers} 
                />
            </Paper>

            <UserForm
                open={openUserForm}
                formMode={userFormMode}
                close={()=>{setOpenUserForm(false)}}
                save={userFormMode === 'add' ? createUserAction : updateUserAction}
                baseUser={newUser}
                roles={roles}
                updateUser={setNewUser}
                confirmLabel="Créer"
            />

            <Dialog open={openDeleteUserForm}>
                <YesNoPopup
                    message="Voulez-vous vraiment supprimer ce(s) utilisateurs ?"
                    no={() => {
                        setOpenDeleteUserForm(false);
                    }}
                    yes={deleteUserAction}
                />
            </Dialog>
        </>
    );
}

export default Users;